// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { Transaction, Account } = initSchema(schema);

export {
  Transaction,
  Account
};